import clsx from 'clsx';
import { FC } from 'react';

interface IProps {
  baseline?: number | null;
  total?: number | null;
  classNames?: {
    baseline?: string;
    total?: string;
  } | null;
}

const PairedProgressBar: FC<IProps> = ({ baseline, total, classNames }) => {
  const safeBaseline = baseline ?? 0;
  const safeTotal = total ?? 0;
  const baselineWidth = safeTotal === 0 ? 0 : (safeBaseline * 100) / safeTotal;
  const totalWidth =
    safeTotal === 0 ? 100 : ((safeTotal - safeBaseline) * 100) / safeTotal;

  return (
    <div className="flex items-center gap-1 px-4 pb-6 w-full">
      <div
        style={{
          width: `${baselineWidth}%`,
        }}
        className={clsx(
          'h-1.5 rounded transition-all duration-300',
          classNames?.baseline,
        )}
      />
      <div
        style={{
          width: `${totalWidth}%`,
        }}
        className={clsx(
          'h-1 rounded transition-all duration-300',
          classNames?.total,
        )}
      />
    </div>
  );
};

export default PairedProgressBar;
